import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Sparkles } from 'lucide-react'
import { Button } from '@meno/ui/components/ui/button'
import TopBar from '@meno/ui/components/layout/TopBar'
import UpdatesModal, { STORAGE_KEY, CURRENT_VERSION } from '@/components/UpdatesModal'
import TaskCenter from '@/components/TaskCenterModal'

export default function BrandingHeader() {
  const { t } = useTranslation()
  const [whatsNewOpen, setWhatsNewOpen] = useState(false)
  // Lazy-init from localStorage so we don't trigger a cascading setState in an
  // effect; the "what's new" dot shows until the operator opens the modal.
  const [hasUnread, setHasUnread] = useState(
    () => localStorage.getItem(STORAGE_KEY) !== CURRENT_VERSION,
  )

  return (
    <>
      <TopBar compactOnPhone>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => { setWhatsNewOpen(true); setHasUnread(false) }}
          className="relative w-8 h-8 rounded-md text-sidebar-foreground/70 hover:text-sidebar-foreground hover:bg-sidebar-accent"
          aria-label={t('whatsNew.title', "What's new")}
        >
          <Sparkles className="w-[14px] h-[14px]" />
          {hasUnread && (
            <span className="absolute top-[6px] end-[6px] w-1.5 h-1.5 bg-primary rounded-full ring-2 ring-sidebar" />
          )}
        </Button>

        {/* Screen Job Tasks — an icon-anchored popover (like the notification
            bell). The red badge counts incomplete tasks (uploads in flight +
            publishes with screens still pending). Hidden on phone — the
            TopBar right cluster is tight enough there already, and the full
            history is always reachable at /activity. */}
        <div className="hidden sm:block">
          <TaskCenter />
        </div>
      </TopBar>
      <UpdatesModal open={whatsNewOpen} onOpenChange={setWhatsNewOpen} />
    </>
  )
}
